import { Role } from 'core/types/role';

export const SET_ROLES = 'SET_ROLES';

export class SetRoles {
  readonly type = SET_ROLES;
  readonly payload: Role[];

  constructor(roles: Role[]) {
    this.payload = roles;
  }
}

export type Action = SetRoles;
